import { render, staticRenderFns } from "./ShopTheLook.vue?vue&type=template&id=7f74d8cc&scoped=true&name=shop-the-look&"
import script from "./ShopTheLook.vue?vue&type=script&lang=js&"
export * from "./ShopTheLook.vue?vue&type=script&lang=js&"
import style0 from "./ShopTheLook.vue?vue&type=style&index=0&id=7f74d8cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f74d8cc",
  null
  
)

/* custom blocks */
import block0 from "./ShopTheLook.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports